<script>
import Layout from "../../layouts/main";
import programmeQuestions from "./programme_questions.vue";
// import Carousel from "vue-owl-carousel";

/**
 * Starter page
 */
export default {
  components: {
    Layout,
    programmeQuestions,
    // Carousel,
  },
  page: {},
  data() {
    return {
      params: this.$route.params,
    };
  },
  mounted() {},

  computed: {},

  methods: {},
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <b-breadcrumb>
      <b-breadcrumb-item>
        <router-link to="/">
          <b-icon
            class="me-2"
            icon="house-fill"
            scale="1.25"
            shift-v="1.25"
            aria-hidden="true"
          ></b-icon>
          Home
        </router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item class="text-capitalize">
        <router-link to="/">
          {{ params.programname }}
        </router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item class="text-capitalize">
        <router-link :to="`/program/${params.programname}/${params.id}`">
          {{ params.subname === "kecermatan" ? "sikap kerja" : params.subname }}
        </router-link>
      </b-breadcrumb-item>
      <b-breadcrumb-item class="text-capitalize">
        {{ params.questioncategory }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <programmeQuestions />
  </Layout>
</template>
